import axios from '../axiosInstance';

export const SearchApi = () => {
  let controller: AbortController | null = null;

  const liveSearch = async (endPoint: string, search: string, params?: Record<string, unknown>) => {
    if (controller) {
      controller.abort();
    }
    controller = new AbortController();

    const response = await axios.get(`/${endPoint}/`, {
      signal: controller.signal,
      params: { search, ...params }
    });

    return response;
  };

  return { liveSearch };
};
